import React, { useState } from 'react'
import './Sidebar.css'
import { Link, useHistory } from 'react-router-dom';

const Sidebar = () => {
  let history = useHistory();

  const activePath = (pathNow) => {
    setPath(pathNow);
    history.push(pathNow);
    // window.location.reload();
    console.log(history);
  }

  let [path, setPath] = useState(history.location.pathname);
  return (
    <>
      <input type="checkbox" id="toggle" />
      <div className="sidebar">
        <div className="sidebar-box">
          <h1>d_board</h1>
        </div>

        <div className="sidebar-links">
          <ul>
            <li><Link to="/" onClick={() => activePath('/')} className={path === "/" ? "active" : null} ><img src={process.env.PUBLIC_URL + '/Home.ico'} alt="" /><span>Dashboard</span></Link></li>

            <li><Link to="/timeline" onClick={() => activePath('/timeline')} className={path === "/timeline" ? "active" : null} ><img src={process.env.PUBLIC_URL + '/Clock.ico'} alt="" /><span>Timeline</span></Link></li>

            <li><Link to="/bag" className={path === "/bag" ? "active" : null} onClick={() => activePath('/bag')}><img src={process.env.PUBLIC_URL + '/Bag.ico'} alt="" /><span>Bag</span></Link></li>

            <li><Link to="/chill" className={path === "/chill" ? "active" : null} onClick={() => activePath('/chill')}><img src={process.env.PUBLIC_URL + '/Speakers.ico'} alt="" /><span>Chill</span></Link></li>

            <li><Link to="/settings" className={path === "/settings" ? "active" : null} onClick={() => activePath('/settings')}><img src={process.env.PUBLIC_URL + '/Setting.ico'} alt="" /><span>Settings</span></Link></li>
          </ul>
        </div>
      </div>
    </>
  )
}

export default Sidebar
